<template>
  <div class="bb-contact-companies-sidebar-clients">
    <router-link
      class="bb-contact-companies-sidebar-clients-item"
      v-for="item in clients"
      :key="item._id"
      target="_blank"
      :to="{name: 'ContactCard', params: {id: item._id, contactType: partnerTypeId}}"
    >
      <img
        v-if="item.image"
        class="bb-contact-companies-sidebar-clients-item__image"
        :src="item.image.path"
      />
      <i
        v-else
        class="icon-user bb-contact-companies-sidebar-clients-item__icon"
      />
      <div class="bb-contact-companies-sidebar-clients-item__text">
        {{item.nickName}}
      </div>
    </router-link>
  </div>
</template>

<script>
import ContactsApi from '@/api/Contacts/api'
import { PARTNER_ID } from '@/constants/clientType'

export default {
  name: 'ContactCompanySidebarClients',
  props: {
    contactId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    clients: [],
    partnerTypeId: PARTNER_ID
  }),
  methods: {
    async getClientByPartner () {
      try {
        const { data } = await ContactsApi.getClientByPartner(this.contactId)
        this.clients = data
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.getClientByPartner()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bb-contact-companies-sidebar-clients {
    padding: 30px 25px 30px 25px;
    display: grid;
    grid-gap: 18px 0;
  }

  .bb-contact-companies-sidebar-clients-item {
    display: flex;
    align-items: center;
    grid-gap: 0 8px;
    text-decoration: none;
    color: $color-black;
    transition: 0.2s;

    &:hover {
      .bb-contact-companies-sidebar-clients-item__text {
        color: $color-denim
      }
    }

    &__image {
      width: 28px;
      height: 28px;
      border-radius: 50%;
    }

    &__icon {
      font-size: 28px;

      &:before {
        margin: 0;
        color: $color-denim;
      }
    }

    &__text {
      font-size: 14px;
      line-height: 17px;
      font-weight: 400;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanySidebar/ContactCompanySidebarClients.vue